import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { FertilizerProductId } from 'services/fertilizerEvents/types';
import { OwnProps } from './index';
import { selectFertilizerWorksheetProductsKeyedById } from '../../../../selectors';

const selectProductId = (
    state: AppState,
    props: OwnProps
): FertilizerProductId => props.productId;

const selectProductNPK = createDeepEqualSelector(
    selectFertilizerWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) => {
        const nitrogenValue = get(
            productsKeyedById,
            [productId, 'fertilizerProduct', 'nitrogenValue'],
            0
        );
        const phosphorusValue = get(
            productsKeyedById,
            [productId, 'fertilizerProduct', 'phosphorusValue'],
            0
        );
        const potassiumValue = get(
            productsKeyedById,
            [productId, 'fertilizerProduct', 'potassiumValue'],
            0
        );

        return `${nitrogenValue}:${phosphorusValue}:${potassiumValue}`;
    }
);

const makeSelectProductNPK = (): typeof selectProductNPK => selectProductNPK;

export { selectProductId, makeSelectProductNPK };
